import React from "react";
import googleIcon from "../assets/google.png";
import instagramIcon from "../assets/instagram.png";
import MapIcon from "../assets/Map.png";
import "./SocialLinks.css";

const SocialLinks = () => {
  return (
    <div className="social-links-container">
      <p className="social-title">Connect With Us</p>

      <div className="social-buttons">

        <button
          className="social-btn google-btn"
          onClick={() =>
            window.open("https://share.google/6GAh5qo4HrLLD10P6", "_blank")
          }
        >
          <img src={googleIcon} alt="Google Business" />
          <span>Google</span>
        </button>

        <button
          className="social-btn insta-btn"
          onClick={() =>
            window.open("https://www.instagram.com/house.of.homoeopathy?igsh=cjRscW9pZGRjaGZq", "_blank")
          }
        >
          <img src={instagramIcon} alt="Instagram" />
          <span>Instagram</span>
        </button>

        <button
          className="social-btn map-btn"
          onClick={() =>
            window.open("https://maps.app.goo.gl/Sc6FkDVmgR6ivmAq8", "_blank")
          }
        >
          <img src={MapIcon} alt="Map" />
          <span>Location</span>
        </button>

      </div>
    </div>
  );
};

export default SocialLinks;